/** @format */

import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';
import Dialog from '@material-ui/core/Dialog';
import DialogActions from '@material-ui/core/DialogActions';
import DialogTitle from '@material-ui/core/DialogTitle';
import withStyles from '@material-ui/core/styles/withStyles';
import adescomStyle from '../../assets/jss/adescom/adescomStyle';
import CustomTextButtom from '../Buttons/CustomTextButton';
import { Button, DialogContent } from '@material-ui/core';
import I18n from '../Translate/I18n';
import oplAppStyle from '../../assets/themes/OPL/jss/App/OplAppStyle';
import GridContainer from '../Grid/GridContainer';
import { ReactComponent as Cancel } from '../../assets/themes/OPL/img/icons/Cancel.svg';

class ViewDialog extends PureComponent {
    handleClose = () => {
        if (this.props.callBackDisAgree) {
            this.props.callBackDisAgree();
        }
    };

    render() {
        const {
            title,
            content,
            agreeButtonName,
            disagreeButtonName,
            open,
            callBackAgree,
            callBackDisAgree,
            maxWidth,
            agreeColor,
            cancelColor,
            fullWidth,
            smallTitleBtn,
            classes,
        } = this.props;
        let width = maxWidth;
        if (width === undefined || width === null) {
            width = 'md';
        }
        let aC = agreeColor;
        if (aC === null) {
            aC = 'primary';
        }
        let cC = cancelColor;
        if (cC === null) {
            cC = 'primary';
        }

        return (
            <Dialog
                maxWidth={width}
                open={open}
                keepMounted
                onClose={callBackDisAgree && disagreeButtonName ? this.handleClose : callBackAgree}
                aria-labelledby="alert-dialog-slide-title"
                aria-describedby="alert-dialog-slide-description"
                fullWidth={fullWidth}
            >
                <DialogTitle id="alert-dialog-slide-title">
                    <GridContainer justifyContent={'space-between'}>
                        <h4>{typeof title === 'string' ? <I18n trans={title}/> : title}</h4>
                        <Button onClick={callBackDisAgree ? this.handleClose : callBackAgree} color="primary">
                            <Cancel width={24} height={24}/>
                        </Button>
                    </GridContainer>
                </DialogTitle>
                <DialogContent>{content}</DialogContent>
                <DialogActions>
                    {callBackDisAgree && disagreeButtonName ? <CustomTextButtom callback={callBackAgree} color={aC} label={agreeButtonName} /> : null}
                </DialogActions>
            </Dialog>
        );
    }
}

ViewDialog.propTypes = {
    title: PropTypes.oneOfType([PropTypes.string, PropTypes.object]),
    content: PropTypes.oneOfType([PropTypes.element]),
    agreeButtonName: PropTypes.string.isRequired,
    disagreeButtonName: PropTypes.string,
    open: PropTypes.bool.isRequired,
    callBackAgree: PropTypes.any,
    callBackDisAgree: PropTypes.func,
    maxWidth: PropTypes.string,
    fullWidth: PropTypes.bool,
};

export default withStyles(oplAppStyle)(ViewDialog);
